import { v4 as uuidv4 } from 'uuid';

import { accountsSelectors } from 'app-components/flux/accounts';

import store from 'app-components/utils/redux-store';

import topTickerSymbols from './topTickerSymbols.ts';

const investmentHoldingsSample = () => {
  const accounts = accountsSelectors.getInvestmentAccounts(store.getState()).toList();
  const account = accounts.first();

  const holdings = topTickerSymbols.map((symbol, index) => ({
    clientId: uuidv4().toUpperCase(),
    accountId: account.id,
    securityType: 'STOCK',
    quantity: topTickerSymbols.length - index,
    securityIdType: 'QCSSYMBOL',
    symbol,
    securityId: symbol,
    // securityName: 'First Priority Clo Bond ETF',
    // currentPrice: 25.06,
    // currentPriceAt: '2024-10-04T08:45:19.267-07:00',
    // marketValue: 25.06,
  }));

  return holdings;
};

export default investmentHoldingsSample;
